import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/ats-resume-builder/ATSResumeBuilderContent.tsx");
